import React from 'react'
import { useTranslation } from 'react-i18next'

import { ContentStateInterface } from '../../../../@types/types'
import { InitState } from '../../../../redux/reducers/root/initialState'
import { useAppSelector } from '../../../../app/hooks'

import priceMaximizerStyle from './PriceMaximizer.module.css'
import { useLoadPriceMaximizerData } from './useLoadPriceMaximizerData'

type PriceMaximizerProps = { insertionData: ContentStateInterface }
const PriceMaximizer: React.FC<PriceMaximizerProps> = (props) => {
  const { t } = useTranslation()

  const { similarObjects, savedSearches } = useAppSelector((state: InitState) => state.priceMaximizerFeature)
  useLoadPriceMaximizerData(props.insertionData)
  if (savedSearches === undefined || similarObjects === undefined) {
    return null
  }
  return (
    <div data-testid='price-maximizer-container' className={'grid-item margin-top-l'}>
      <div className={`grid-item ${priceMaximizerStyle['folding-section-wrap']}`}>
        <div className={`${priceMaximizerStyle['folding-section-header']}`}>
          <h6>{t('priceMaximizer.header', 'Price Maximizer')}</h6>
        </div>
        <div className={`${priceMaximizerStyle['circles-container']}`}>
          <div
            id='similar-objects'
            data-testid='similar-objects-testid'
            className={`${priceMaximizerStyle['single-circle-container']} ${priceMaximizerStyle['small-circle']}`}
          >
            <span>{similarObjects}</span>
            <label id='similar-objects-label' className='font-highlight' htmlFor='similar-objects'>
              <span>{t('priceMaximizer.similarObjectsLabel', 'Similar Objects')}</span>
            </label>
          </div>

          <div
            id='saved-searches'
            data-testid='saved-searches-testid'
            className={`${priceMaximizerStyle['single-circle-container']} ${priceMaximizerStyle['big-circle']}`}
          >
            <span>{savedSearches}</span>
            <label id='saved-searches-label' className='font-highlight' htmlFor='saved-searches'>
              <span>{t('priceMaximizer.savedSearchesLabel', 'Saved searches')}</span>
            </label>
          </div>
        </div>
        <div
          data-testid='tooltip-test-id'
          className={`${priceMaximizerStyle['saved-searches-tooltip']} ${priceMaximizerStyle['folding-tooltip']}`}
        >
          <strong>{savedSearches} </strong>
          {t('priceMaximizer.savedSearchesTooltip', 'saved searches tooltip')}
        </div>
      </div>
    </div>
  )
}

export default PriceMaximizer
